import { IEnvironment } from './environment.interface';
export const environment: IEnvironment = {
  production: true,
  api: 'https://api.mytrans.ttgt.dev/admin/',
  auth0: {
    domain: 'ducminhquan.auth0.com',
    clientID: '7wBvhyXrTZ3b2npBB7bjqA6N3MVp8zuv',
    audience: 'https://ducminhquan.auth0.com/userinfo',
    callback: 'https://feedback.mytrans.ttgt.dev/#/callback/',
  },
};



// WEBPACK FOOTER //
// /ng-app/src/environments/environment.ts